import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { trackProductEvent } from 'src/app/utils/product-analytics.util';

const ANALYTICS_BUFFER_KEY = 'ss_billing_analytics_buffer';
const BUFFER_MAX = 500;

export type BillingAnalyticsEvent = {
  name: string;
  payload?: Record<string, unknown>;
  at: number;
};

/**
 * Billing funnel analytics (SUSEE-1547). Buffers locally and dual-sends Clarity + GTM.
 */
@Injectable({ providedIn: 'root' })
export class BillingAnalyticsService {
  track(name: string, payload?: Record<string, unknown>): void {
    if (!name) {
      return;
    }
    const event: BillingAnalyticsEvent = {
      name,
      payload: payload && Object.keys(payload).length ? payload : undefined,
      at: Date.now(),
    };

    try {
      const bufRaw = localStorage.getItem(ANALYTICS_BUFFER_KEY);
      const buf: BillingAnalyticsEvent[] = bufRaw ? JSON.parse(bufRaw) : [];
      buf.push(event);
      localStorage.setItem(ANALYTICS_BUFFER_KEY, JSON.stringify(buf.slice(-BUFFER_MAX)));
    } catch {
      /* best-effort */
    }

    if (environment.enableLogs && typeof console !== 'undefined') {
      console.debug('[BillingAnalytics]', name, payload || {});
    }

    try {
      trackProductEvent(name, payload);
    } catch {
      /* optional sinks */
    }
  }
}
